export default "Redirecting, please wait...";